import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_UNITS_SUCCESS,
  UPDATE_PREVIOUS_TOGGLE,
  FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS
} from "./membershipUnitsSagas";

export const initialState = {
  initRequest: false,
  prevPageFilters: { prevDate: null },
  membershipUnits: {
    churnRate: {},
    totalActive: {},
    totalFrozen: {},
    cancelledPayingMembers: {},
    totalNewMembers: {},
    scheduledCancellations: {}
  },
  membersAtRisk: {
    membersAtRiskNumber: 0
  },
  previousToggleValue: false,
  initialized: false,
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [UPDATE_PREVIOUS_TOGGLE]: (state, action) => ({
      ...state,
      previousToggleValue: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [FETCH_MEMBERSHIP_UNITS_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      membershipUnits: action.payload || state.membershipUnits
    }),
    [FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload || state.chartData
    })
  },
  initialState
);
